<template>
  <!--<div class="container">-->
  <div class="columns is-vcentered is-desktop is-mobile is-full-height is-centered">
    <!--<div class="column is-half  ">-->
    <!--<img class="login-logo" src="@/assets/img/digi-logo.png">-->
    <!--</div>-->
    <div :class="{'is-active':showConfirmModal}" class="modal">
      <div class="modal-background" @click.prevent="showConfirmModal=false"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Request Sent</p>
          <button aria-label="close" class="delete" @click.prevent="showConfirmModal=false"></button>
        </header>
        <section class="modal-card-body">
          <p>A password reset link has been emailed to you. Please click the link and follow the steps as prompted. Remember to check your spam folder.</p>
        </section>
        <footer class="modal-card-foot">

          <b-button type="is-primary" @click.prevent="showConfirmModal=false">Close</b-button>
        </footer>
      </div>
    </div>

    <div class="column is-6-desktop is-10-tablet is-12-mobile login-form">
      <div class="columns is-centered">
        <div class="column is-4">
          <img alt="Forgot Password logo" class="login-logo"
                 v-if="!isWhiteLabeled"
                 src="https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-02.svg"/>
            <img alt="Login logo" class="login-logo"
                 v-else
                 :src="expandedLogoUrl"
            />
          </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-8">
          <div class="login">
            <div class="login-content">
              <!--<img class="login-logo" src="@/assets/img/genex-logo.svg">-->
              <p class="pb-4">Please enter in your email address to request a password reset. A recovery link will then
                be emailed to
                you.</p>
              <div class="login-form">
                <form v-on:submit.prevent="sendForgotRequest">
                  <b-field>
                    <b-input v-model="email"
                              placeholder="Email" required type="email"/>
                  </b-field>


                  <b-field grouped>
                    <p class="control">
                      <b-button tag="router-link" type="is-warning" :to="slug && isWhiteLabeled ? `/login/${slug}` : '/login'">Cancel</b-button>
                    </p>

                    <p class="control">
                      <b-button native-type="submit" type="is-primary">
                        Submit
                      </b-button>
                    </p>
                  </b-field>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--</div>-->
</template>
<script>

import {AuthClient} from "@/clients/AuthClient";
import {mapGetters} from "vuex";

export default {
  name: "ForgotPassword",
  data() {
    return {
      email: null,
      showConfirmModal: false,
      slug: this.$cookies.get('tenant_slug') || null
    };
  },

  computed:{
    ...mapGetters("tenant", ["expandedLogoUrl", "isWhiteLabeled"])
  },

  methods: {

    sendForgotRequest() {
      let data = {
        email: this.email,
      };
      AuthClient.sendForgotPassword(data).then(()=>{
        this.showConfirmModal = true
        this.email = null
      }).catch(
          err => {
            this.handleError(err)
          }
      )


    },
  },
};
</script>
